<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1" style="">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="tickets"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("setup.label.group_ticketing") }}
                    </div>
                    <div class="mr-2 mb-1 order-1">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="
                          $router.push({ name: 'Create Group Ticketing' })
                        "
                        size="small"
                        >{{ $t("setup.label.create_group_ticket") }}</vs-button
                      >
                    </div>
                    <div style="margin-right: -7rem;" class="mb-1 order-1">
                      <div class="flex items-center mb-3">
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="start-date"
                    :placeholder="$t('customers.label.start_date')"
                    v-model="orderSearch.startDate"
                  ></datepicker>
                </div>
                <div class="p-1 mt-2 flex items-center text-lg font-medium w-full date-field">
                  <datepicker
                    name="end-date"
                    class="end-date-calender"
                    :placeholder="$t('customers.label.end_date')"
                    v-model="orderSearch.endDate"
                  ></datepicker>
                </div>
                <div class="p-1 flex items-center text-lg font-medium w-full">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    class="mr-sm-3 mt-2"
                    icon="icon-search"
                    @click="searchOrderList"
                  ></vs-button>
                </div>
              </div>
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("customers.label.id") }}</vs-th>
                    <vs-th>{{ $t("customers.label.priority") }}</vs-th>
                    <vs-th>{{ $t("customers.label.title") }}</vs-th>
                    <vs-th>{{ $t("setup.label.groupName") }}</vs-th>
                    <vs-th>{{ $t("admin.label.Created Date") }}</vs-th>
                    <vs-th>{{ $t("customers.label.status") }}</vs-th>
                    <vs-th>{{ $t("customers.label.action") }}</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="ticket"
                      v-for="(ticket, index) in data"
                    >
                      <vs-td :data="ticket.id">{{ ticket.id }}</vs-td>
                      <vs-td :data="ticket.severity">{{
                        ticket.severity
                      }}</vs-td>
                      <vs-td :data="ticket.title">{{ ticket.title }}</vs-td>
                      <vs-td :data="ticket.groupName">{{
                        ticket.groupName
                      }}</vs-td>
                      <vs-td :data="getDate(ticket.createdDate)">{{
                        getDate(ticket.createdDate)
                      }}</vs-td>
                      <vs-td :data="ticket.status">
                        <vs-chip
                          :color="statusColor(ticket.status)"
                          class="availability-status"
                          >{{ ticket.status }}
                        </vs-chip></vs-td
                      >
                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="viewTicket(ticket)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            title="Edit"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editTicket(ticket.id)"
                            class="icon_row"
                            v-if="
                              ticket.status &&
                              ticket.status.toUpperCase() !== 'CLOSED'
                            "
                          />
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('setup.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            @click.stop="
                              deleteTicketPopup = true;
                              delId = ticket.id;
                            "
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <delete-popup
          :deletePopup="deleteTicketPopup"
          :title="$t('setup.label.group_ticketing')"
          @deletePressed="deleteTicket(delId)"
          @cancelPressed="deleteTicketPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteTicketPopup: false,
      delId: null,
      orderSearch: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    AtomSpinner,
    Datepicker,
  },

  computed: {
    ...mapState({
      tickets: (state) => state.groupTicketing.allGroupTickets,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    viewTicket(ticket) {
      this.$router.push({
        name: "View Group Ticketing",
        params: { id: ticket.id, categoryId: ticket.categoryId },
      });
    },
    editTicket(id) {
      this.$router.push({
        name: "Edit Group Ticketing",
        params: { id: id },
      });
    },
    async deleteTicket(id) {
      this.deleteTicketPopup = false;
      try {
        const data = {
          id: id,
          forceDelete: false,
        };
        await this.$store.dispatch("groupTicketing/deleteGroupTicket", data);
        this.getGroupTicketData();
        this.$swal({
          title: "Success",
          text: "Group Ticketing Deleted Successfully",
          icon: "success",
        });
      } catch (error) {
        let errorMsg = error && error.toString();
        let e = errorMsg.replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          html: `<h5 style='display: block; text-align: center;'>${e}</h5>`,
          icon: "error",
          showCancelButton: true,
          confirmButtonText: "Force Delete",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#FF0000",
          customClass: {
            confirmButton: "no-outline-btn",
            cancelButton: "no-outline-btn",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.forceDelete(id);
          }
        });
      }
    },
    async searchOrderList() {
      this.loading = true;
  try {
    const payload = {
      startDate: this.orderSearch.startDate 
        ? moment(this.orderSearch.startDate).format("YYYY-MM-DD")
        : null,
      endDate: this.orderSearch.endDate
        ? moment(this.orderSearch.endDate).format("YYYY-MM-DD")
        : null,
    };
    console.log("Payload for order search:", payload);

    if (payload.startDate && payload.endDate && payload.startDate > payload.endDate) {
      this.$toasted.error("Start date cannot be greater than end date", { duration: 2000 });
      this.loading = false;
      return;
    }

    await this.$store.dispatch("groupTicketing/getOrderGroupTicketDateFilterAction", payload);
  } catch (error) {
    this.$toasted.error(error.message || "Failed to fetch orders", { duration: 2000 });
  } finally {
    this.loading = false;
  }
    },
    async forceDelete(id) {
      try {
        const data = {
          id: id,
          forceDelete: true,
        };
        await this.$store.dispatch("groupTicketing/deleteGroupTicket", data);
        this.getGroupTicketData();
        this.$swal({
          title: "Success",
          text: "Group Ticketing Force Deleted Successfully",
          icon: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error,
          icon: "error",
        });
      }
    },
    statusColor(status) {
      switch (status.toUpperCase()) {
        case "OPEN":
          return "open";
        case "CLOSED":
          return "closed";
        case "IN_PROGRESS":
          return "in-progress";
        case "RESOLVED":
          return "resolved";
        case "REOPEN":
          return "reopen";
        default:
          return "default-status";
      }
    },
    async getGroupTicketData() {
      this.loading = true;
      try {
        this.$store.dispatch("groupTicketing/getAllGroupTickets");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getGroupTicketData();
  },
};
</script>
<style>
.no-outline-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}
</style>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.availability-status.vs-chip-open {
  background: #d6eaff !important;
  border: 1px solid #3399ff;
  color: #3399ff !important;
}

.availability-status.vs-chip-closed {
  background: #ffd6d6 !important;
  border: 1px solid #ff4d4f;
  color: #ff4d4f !important;
}

.availability-status.vs-chip-in-progress {
  background: #d2f8d2 !important;
  border: 1px solid #28a745;
  color: #28a745 !important;
}

.availability-status.vs-chip-resolved {
  background: #e0fce0 !important;
  border: 1px solid #2ecc71;
  color: #2ecc71 !important;
}

.availability-status.vs-chip-reopen {
  background: #fff1d6 !important;
  border: 1px solid #ff9800;
  color: #ff9800 !important;
}

.availability-status.vs-chip-default-status {
  background: #f0f0f0 !important;
  border: 1px solid #999;
  color: #666 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.container_img {
  margin-left: -40px !important;
}
</style>
